export const DASH_COLORS = {
  livre: '#BAD424',
  restalivrer: '#4A90E2',
  retard: '#6A5ACD',
  deliveredAccent: '#13a026ff',
  remainingAccent: '#85C1E9',
};

export const GAUGE_SEGMENTS = [DASH_COLORS.restalivrer, DASH_COLORS.restalivrer, DASH_COLORS.livre, DASH_COLORS.livre];

export const VBAR_SEGMENTS = [DASH_COLORS.livre, DASH_COLORS.restalivrer, DASH_COLORS.retard];
